export enum RecurringActionAuthorize {
    CreditCardHolder,
    Customer,
    SupportTeamServiceTeam
}